import React from 'react'
import { useRouteError } from 'react-router-dom'
import { ApolloError, isApolloError } from '@apollo/client'

import { ErrorPageContent, Layout } from 'components'
import { ClientError } from 'modules/Errors/components'
import styles from './errors.module.scss'

export const ClientErrorPage = () => {
  const error = useRouteError() as ApolloError
  let title = ''
  let description = ''
  if (isApolloError(error)) {
    /* eslint-disable @typescript-eslint/ban-ts-comment */
    if (error.graphQLErrors.length > 0) {
      const gqlError = error.graphQLErrors[0]


      // @ts-ignore
      if (gqlError.errorType === 'NotExists') {
        title = 'Not Found'
        description = gqlError.message
      } else {
        // @ts-ignore
        if (gqlError.errorType === 'PermissionDenied') {
          title = 'Access Denied'
          description = gqlError.message
        }
      }
    } else {
      title = error.name
      description = error.message
    }
    /* eslint-enable @typescript-eslint/ban-ts-comment */
  }

  return (
    <Layout>
      <ErrorPageContent
        title={title}
        description={description}
        children={<ClientError />}
      />
      {process.env.REACT_APP_STAGE === 'dev' && (
        <div className={styles.codeContainer}>
          <h4 className={'lgt-title'} style={{ color: 'red' }}>*This block is visible only on dev env</h4>
          <code>
            <pre>{JSON.stringify(error, null, ' ')}</pre>
          </code>
        </div>
      )}
    </Layout>
  )
}
